import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import routes from './routes.json';
import HomePage from './pages/HomePage';
import AboutUs from './pages/AboutUs';
import NYSEDGrant2025 from './pages/NYSEDGrant2025';
import LTGPhase1 from './pages/LTGPhase1';
import LTGPhase2 from './pages/LTGPhase2';
import LTGPhase3 from './pages/LTGPhase3';
import PrincipalMessage from './pages/PrincipalMessage';
import GuidanceCounseling from './pages/GuidanceCounseling';
import RelatedServices from './pages/RelatedServices';
import Enrichment from './pages/Enrichment';
import ComputerScience from './pages/ComputerScience';
import CreativeWriting from './pages/CreativeWriting';
import Hydroponics from './pages/Hydroponics';
import PhysicalEducation from './pages/PhysicalEducation';
import SocialStudies from './pages/SocialStudies';
import TheArts from './pages/TheArts';
import Contact from './pages/Contact';
import OutOfClassroom from './pages/OutOfClassroom';
import Paraprofessionals from './pages/Paraprofessionals';
import SchoolSecretaries from './pages/SchoolSecretaries';
import SchoolAides from './pages/SchoolAides';
import FamilyWorker from './pages/FamilyWorker';
import Calendar from './pages/Calendar';
import Newsletters from './pages/Newsletters';
import OurClasses from './pages/OurClasses';
import TechnologyResources from './pages/TechnologyResources';
import Announcements from './pages/Announcements';
import Curriculum from './pages/Curriculum';
import ComingSoon from './pages/ComingSoon';

// To ADD a page: create the component, import it below, add it to `registry`,
// and add a `{ path, component, title }` entry to src/routes.json.
// To REMOVE a page: delete the component file, its import, its registry entry,
// and its src/routes.json entry. routes.json is the single source of truth that
// drives both this router and scripts/prerender.mjs.
const registry = {
  HomePage,
  AboutUs,
  NYSEDGrant2025,
  LTGPhase1,
  LTGPhase2,
  LTGPhase3,
  PrincipalMessage,
  GuidanceCounseling,
  RelatedServices,
  Enrichment,
  ComputerScience,
  CreativeWriting,
  Hydroponics,
  PhysicalEducation,
  SocialStudies,
  TheArts,
  Contact,
  OutOfClassroom,
  Paraprofessionals,
  SchoolSecretaries,
  SchoolAides,
  FamilyWorker,
  Calendar,
  Newsletters,
  OurClasses,
  TechnologyResources,
  Announcements,
  Curriculum,
  ComingSoon,
};

function App() {
  return (
    <Router>
      <Routes>
        {routes.map(({ path, component }) => {
          const C = registry[component];
          return C ? <Route key={path} path={path} element={<C />} /> : null;
        })}
      </Routes>
    </Router>
  );
}

export default App;
